"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistAudiotrack = exports.silenceAudioBase64 = exports.LOGGABLE_HOWL_EVENTS = exports.LOGGABLE_AUDIO_ELEMENT_EVENTS = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.to-fixed.js");

var _audioPanner = require("./audioPanner");

var _AssetEnvelope = require("./mixer/AssetEnvelope");

var _TrackOptions = require("./mixer/TrackOptions");

var _TrackStates = require("./TrackStates");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
@see https://github.com/loafofpiecrust/roundware-ios-framework-v2/blob/client-mixing/RWFramework/RWFramework/Playlist/AudioTrack.swift

 Audiotracks data looks like this:

 [{
   "id": 8,
   "minvolume": 0.7,
   "maxvolume": 0.7,
   "minduration": 200.0,
   "maxduration": 250.0,
   "mindeadair": 1.0,
   "maxdeadair": 3.0,
   "minfadeintime": 2.0,
   "maxfadeintime": 4.0,
   "minfadeouttime": 0.3,
   "maxfadeouttime": 1.0,
   "minpanpos": 0.0,
   "maxpanpos": 0.0,
   "minpanduration": 10.0,
   "maxpanduration": 20.0,
   "repeatrecordings": false,
   "active": true,
   "start_with_silence": false,
   "banned_duration": 600,
   "tag_filters": [],
   "project_id": 9
 }]


 asset looks like:

 {
  alt_text_loc_ids: []
  audio_length_in_seconds: 14.4
  created: "2019-03-13T20:09:34.237155"
  description: ""
  description_loc_ids: []
  end_time: 14.396
  envelope_ids: [6204]
  file: "https://prod.roundware.com/rwmedia/20190313-200933-43867.mp3"
  filename: "20190313-200933-43867.wav"
  id: 11511
  language_id: 1
  latitude: 42.4985662
  longitude: -71.2809467
  media_type: "audio"
  project_id: 27
  session_id: 43867
  shape: null
  start_time: 0
  submitted: true
  tag_ids: [290]
  updated: "2019-03-13T20:09:34.237155"
  user: null
  volume: 1
  weight: 50
  }

*/
//const LOGGABLE_AUDIO_ELEMENT_EVENTS = ['loadstart','playing','stalled','waiting']; // see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement#Events
var LOGGABLE_AUDIO_ELEMENT_EVENTS = ["pause", "play", "playing", "waiting", "stalled", "about", "canplay", "canplaythrough", "ended", "error", "loadeddata", "loadstart"]; // see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement#Events

exports.LOGGABLE_AUDIO_ELEMENT_EVENTS = LOGGABLE_AUDIO_ELEMENT_EVENTS;
var LOGGABLE_HOWL_EVENTS = ["load", "loaderror", "playerror", "play", "end", "pause", "stop", "mute", "volume", "rate", "seek", "fade", "unlock"];
exports.LOGGABLE_HOWL_EVENTS = LOGGABLE_HOWL_EVENTS;
var silenceAudioBase64 = "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
exports.silenceAudioBase64 = silenceAudioBase64;

var PlaylistAudiotrack = /*#__PURE__*/function () {
  /**
   * id of audiotrack
   * @type {number}
   * @memberof PlaylistAudiotrack
   */

  /**
   * @type {Playlist}
   * @memberof PlaylistAudiotrack
   */

  /**
   *
   * Logs asset events to roundware server
   * @type {RoundwareEvents}
   * @memberof PlaylistAudiotrack
   */
  function PlaylistAudiotrack(_ref) {
    var _this = this;

    var audioContext = _ref.audioContext,
        windowScope = _ref.windowScope,
        audioData = _ref.audioData,
        playlist = _ref.playlist,
        client = _ref.client;

    _classCallCheck(this, PlaylistAudiotrack);

    _defineProperty(this, "played", false);

    _defineProperty(this, "pausedAssetId", null);

    _defineProperty(this, "isSafeToPlay", false);

    this.trackId = audioData.id;
    this.timedAssetPriority = audioData.timed_asset_priority;
    this.playlist = playlist;
    this.playing = false;
    this.windowScope = windowScope;
    this.listenEvents = client.events;
    this.currentAsset = null;
    this.audioData = audioData;
    var audioElement = new Audio();
    audioElement.crossOrigin = "anonymous";
    audioElement.loop = false;
    audioElement.src = silenceAudioBase64;
    var audioSrc = audioContext.createMediaElementSource(audioElement);
    this.gainNode = audioContext.createGain();
    var panNode = audioContext.createStereoPanner();
    audioSrc.connect(panNode).connect(this.gainNode).connect(audioContext.destination); // LOGGABLE_AUDIO_ELEMENT_EVENTS.forEach((name) =>
    //   audioElement.addEventListener(name, () =>
    //     console.log(`\t[${this} audio ${name} event]`)
    //   )
    // );

    audioElement.addEventListener("error", function () {
      return _this.onAudioError();
    });
    audioElement.addEventListener("ended", function () {
      return _this.onAudioEnded();
    });
    var trackOptions = new _TrackOptions.TrackOptions(function (param) {
      return (0, _utils.getUrlParam)(windowScope.location.toString(), param);
    }, audioData);
    audioElement.addEventListener("playing", function () {
      if (!_this.isSafeToPlay) return;
      if (_this.playlist.playing === false) return _this.pauseAudio();
      _this.currentAsset.status = undefined;

      if (_this.currentAsset) {
        var _this$listenEvents;

        (_this$listenEvents = _this.listenEvents) === null || _this$listenEvents === void 0 ? void 0 : _this$listenEvents.logAssetStart(_this.currentAsset.id);
        _this.playing = true;
        _this.played = true;
      }
    });
    audioElement.addEventListener("pause", function () {
      var _this$listenEvents2, _this$currentAsset;

      _this.playing = false;
      (_this$listenEvents2 = _this.listenEvents) === null || _this$listenEvents2 === void 0 ? void 0 : _this$listenEvents2.logAssetEnd((_this$currentAsset = _this.currentAsset) === null || _this$currentAsset === void 0 ? void 0 : _this$currentAsset.id);
    });
    audioElement.addEventListener("end", function () {
      var _this$listenEvents3, _this$currentAsset2;

      return (_this$listenEvents3 = _this.listenEvents) === null || _this$listenEvents3 === void 0 ? void 0 : _this$listenEvents3.logAssetEnd((_this$currentAsset2 = _this.currentAsset) === null || _this$currentAsset2 === void 0 ? void 0 : _this$currentAsset2.id);
    });
    this.audioContext = audioContext;
    this.audioElement = audioElement;
    this.trackOptions = trackOptions;
    this.mixParams = {
      timedAssetPriority: audioData.timed_asset_priority
    };
    var minpanpos = audioData.minpanpos,
        maxpanpos = audioData.maxpanpos,
        minpanduration = audioData.minpanduration,
        maxpanduration = audioData.maxpanduration;
    this.audioPanner = new _audioPanner.AudioPanner(minpanpos, maxpanpos, minpanduration, maxpanduration, panNode, audioContext);
    this.audioPanner.start();
    this.setInitialTrackState(); // try to play silence audio to avoid NotAllowedError on iOS

    (0, _utils.makeAudioSafeToPlay)(this.audioElement, function () {
      return _this.isSafeToPlay = true;
    });
  }

  _createClass(PlaylistAudiotrack, [{
    key: "setInitialTrackState",
    value: function setInitialTrackState() {
      this.state = (0, _TrackStates.makeInitialTrackState)(this, this.trackOptions);
    }
  }, {
    key: "onAudioError",
    value: function onAudioError(evt) {
      (0, _utils.playlistTrackLog)("".concat(this, " audio error, skipping to next track"));
      this.setInitialTrackState();
    }
  }, {
    key: "onAudioEnded",
    value: function onAudioEnded() {
      (0, _utils.playlistTrackLog)("".concat(this, " audio ended event"));
    }
  }, {
    key: "play",
    value: function play() {
      if (!this.state) return;
      this.state.play();
    }
  }, {
    key: "updateParams",
    value: function updateParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.mixParams = _objectSpread(_objectSpread({}, this.mixParams), params);
      if (this.state) this.state.updateParams(this.mixParams);
    } // Halts any scheduled gain changes and holds at current level
    // @see https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/cancelAndHoldAtTime

  }, {
    key: "holdGain",
    value: function holdGain() {
      this.gainNode.gain.cancelScheduledValues(0);
    }
  }, {
    key: "setZeroGain",
    value: function setZeroGain() {
      this.gainNode.gain.value = 0;
    }
  }, {
    key: "fadeIn",
    value: function fadeIn(fadeInDurationSeconds) {
      var currentAsset = this.currentAsset;
      if (!currentAsset || !currentAsset.volume) return false;
      var randomVolume = this.trackOptions.randomVolume;
      var finalVolume = randomVolume * currentAsset.volume;

      try {
        this.setZeroGain();
        this.rampGain(finalVolume, fadeInDurationSeconds);
        return true;
      } catch (err) {
        (0, _utils.playlistTrackLog)("".concat(this, " unable to fadeIn"));
        return false;
      }
    }
    /**
     * Schedules a Fade out and returns true if success
     *
     * @param {number} fadeOutDurationSeconds
     * @return {*}  {boolean}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "fadeOut",
    value: function fadeOut(fadeOutDurationSeconds) {
      var _this$currentAsset3, _this$currentAsset4;

      if (fadeOutDurationSeconds > ((_this$currentAsset3 = this.currentAsset) === null || _this$currentAsset3 === void 0 ? void 0 : _this$currentAsset3.audio_length_in_seconds) - this.audioElement.currentTime) fadeOutDurationSeconds = ((_this$currentAsset4 = this.currentAsset) === null || _this$currentAsset4 === void 0 ? void 0 : _this$currentAsset4.audio_length_in_seconds) - this.audioElement.currentTime;
      return this.rampGain(0, fadeOutDurationSeconds);
    }
  }, {
    key: "rampGain",
    value: function rampGain(finalVolume, durationSeconds) {
      var rampMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "linearRampToValueAtTime";
      console.log("\t[ramping gain from ".concat(this.gainNode.gain.value, " to ").concat(finalVolume.toFixed(2), " (").concat(durationSeconds.toFixed(1), "s - ").concat(rampMethod, ")]"));

      try {
        this.gainNode.gain.setValueAtTime(this.gainNode.gain.value, this.audioContext.currentTime);
        this.gainNode.gain[rampMethod](finalVolume, this.audioContext.currentTime + durationSeconds);
        return true;
      } catch (err) {
        console.warn("Unable to ramp gain ".concat(this), err);
        return false;
      }
    }
    /**
     *This will perform cleanup, get next asset to play and update/set the `src` property to current audio
     *
     * @return {*}  {(IAssetData | null)}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "loadNextAsset",
    value: function loadNextAsset() {
      var audioElement = this.audioElement,
          currentAsset = this.currentAsset,
          trackOptions = this.trackOptions; // if current asset was not played at all then don't increase playCount

      if (currentAsset && this.played) {
        if (!currentAsset.playCount) currentAsset.playCount = 0;
        if (currentAsset.status !== "paused") currentAsset.playCount++;
        currentAsset.lastListenTime = new Date();
      }

      var newAsset = this.playlist.next(this);
      this.currentAsset = newAsset || null;

      if (newAsset) {
        var file = newAsset.file,
            start_time = newAsset.start_time;
        (0, _utils.playlistTrackLog)("#".concat(this.trackId, " Selected Asset: ").concat(newAsset.id, ", was paused: ").concat(newAsset.paused || false, "]"));
        this.assetEnvelope = new _AssetEnvelope.AssetEnvelope(trackOptions, newAsset);

        if (typeof file !== "string") {
          return null;
        }

        audioElement.src = file;
        audioElement.addEventListener("loadedmetadata", function () {
          if (newAsset.status === "resumed") audioElement.currentTime = newAsset.resume_time || start_time;else audioElement.currentTime = start_time;
        }, {
          once: true
        });
        this.audioElement = audioElement;
        this.played = false;
        return newAsset;
      }

      return null;
    }
  }, {
    key: "pause",
    value: function pause() {
      (0, _utils.playlistTrackLog)("".concat(_utils.timestamp, " pausing ").concat(this));
      if (!this.state) return;
      this.state.pause();
      this.pauseAudio();
    }
  }, {
    key: "playAudio",
    value: function playAudio() {
      try {
        if (this.audioContext.state !== "running") this.audioContext.resume();
        if (!this.audioElement.src) this.audioElement.src = silenceAudioBase64;
        this.audioElement.play();
      } catch (e) {
        console.error(e);
        this.setInitialTrackState();
        this.transition(this.state);
      }
    }
  }, {
    key: "pauseAudio",
    value: function pauseAudio() {
      this.audioElement.pause();
    }
    /**
     *
     * Fade Out currently playing asset quickly and get nextAsset
     * @return {void}
     * @memberof PlaylistAudiotrack
     */

  }, {
    key: "skip",
    value: function skip() {
      var _this2 = this;

      if (!this.playlist.playing) {
        this.setInitialTrackState();
        return;
      }

      this.fadeOut(this.trackOptions.fadeOutLowerBound);
      setTimeout(function () {
        var _this2$listenEvents, _this2$currentAsset;

        _this2.pauseAudio();

        (_this2$listenEvents = _this2.listenEvents) === null || _this2$listenEvents === void 0 ? void 0 : _this2$listenEvents.logAssetEnd((_this2$currentAsset = _this2.currentAsset) === null || _this2$currentAsset === void 0 ? void 0 : _this2$currentAsset.id);
        var newState = (0, _TrackStates.makeInitialTrackState)(_this2, _this2.trackOptions);
        if (_this2.playlist.playing) _this2.transition(newState);
      }, this.trackOptions.fadeOutLowerBound * 1000);
    }
  }, {
    key: "replay",
    value: function replay() {
      var state = this.state;
      (0, _utils.playlistTrackLog)("Replaying ".concat(this));
      if (state) state.replay();
    }
  }, {
    key: "transition",
    value: function transition(newState) {
      var state = this.state,
          elapsedTimeMs = this.playlist.elapsedTimeMs;
      (0, _utils.playlistTrackLog)("".concat(_utils.timestamp, " ").concat(this, ": '").concat(state, "' \u279C  '").concat(newState, "' (").concat((elapsedTimeMs / 1000).toFixed(1), "s elapsed)"));
      if (!this.state) return;
      this.state.finish();
      this.state = newState;
      if (this.playlist.playing) this.state.play();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Track #".concat(this.trackId);
    }
  }]);

  return PlaylistAudiotrack;
}();

exports.PlaylistAudiotrack = PlaylistAudiotrack;